import { Calendar, Envelope, TelegramLogo } from "@phosphor-icons/react"
import { LinkButton } from "@tokenterminal/core/ui/button/LinkButton"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Card } from "@tokenterminal/core/ui/layout/card/Card"
import { twMerge } from "tailwind-merge"
import Container from "../common/Container"
import MarketingHeading from "../common/MarketingHeading"

const emailAddress = "people@tokenterminal.xyz"
const subject = "Contact Token Terminal"
const mailToLink = `mailto:${emailAddress}?subject=${subject}`

const containerCss = "pt-[20px] pb-[50px] md:pt-[50px] md:pb-[100px]"
const headingCss =
  "text-[36px] md:text-[46px] font-medium text-center  leading-[0.9em]"

const ContactUs = () => {
  return (
    <Container
      className={twMerge(
        "flex flex-col gap-6 items-center justify-center",
        containerCss
      )}
    >
      <Card
        className="rounded-2xl p-[50px] md:p-[150px] bg-bg-surface w-full px-12 py-16"
        style={{
          maxWidth: "100%",
        }}
      >
        <div className="flex flex-col gap-8 items-center justify-center">
          <MarketingHeading level={1} as="h2" className={headingCss}>
            Talk to our team
          </MarketingHeading>
          <div
            className="flex flex-col gap-4 items-center justify-center"
            style={{ width: "300px" }}
          >
            <LinkButton
              size="large"
              className="w-full"
              target="_blank"
              href="https://t.me/TokenTerminalHQ"
            >
              <Icon as={TelegramLogo} />
              Chat on Telegram
            </LinkButton>
            <LinkButton size="large" className="w-full" href="/contact">
              <Icon as={Calendar} />
              Book a demo
            </LinkButton>
            <LinkButton
              size="large"
              className="w-full"
              target="_blank"
              href={mailToLink}
            >
              <Icon as={Envelope} />
              Email us
            </LinkButton>
          </div>
          {/* Potentially add this back */}
          {/* <div className="flex flex-col gap-4 items-center justify-center">
            <Input placeholder="Email" />
            <Input placeholder="Telegram handle (optional)" />
            <Input placeholder="How can we help you? (optional)" />
            <ButtonV4 size="large" width="100%">
              Submit
            </ButtonV4>
            <Divider />
            <Text size="14" color="secondary">
              Or send us an email at&nbsp;
              <Link
                href="mailto:people@tokenterminal.xyz"
                display="inline"
                style={{ color: "#7EFFDE" }}
              >
                people@tokenterminal.xyz
              </Link>
            </Text>
          </Stack> */}
        </div>
      </Card>
    </Container>
  )
}

export default ContactUs
